<link
  href="https://fonts.googleapis.com/icon?family=Material+Icons"
  rel="stylesheet"
/>
<mat-sidenav-container>
  <!--  The side nave content -->
  <mat-sidenav
    [opened]="sidebar.SideNavOpen"
    [mode]="sidebar.SideNavMode"
    class="tw-m-0 tw-p-0 m-0"
    fixedInViewport="true"
    style="width: 268px"
    (closed)="closeSideNav()"
  >
    <!--    SIDENAV CONTENT OPTIONS -->
    <ng-scrollbar visibility="hover">
      <div class="sidebar open">
        <div
          class="logo-details"
          [matMenuTriggerFor]="menuSideNav"
          *ngIf="sidebar.SideBars.length > 1"
        >
          <img
            [src]="sidebar.ActiveSidebar.img"
            height="50"
            width="50"
            alt=""
          />
          <div class="logo_name">{{ sidebar.ActiveSidebar.name }}</div>
          <mat-icon class="sidenav-icon-menu">expand_more</mat-icon>
        </div>

        <div class="logo-details" *ngIf="sidebar.SideBars.length === 1">
          <img
            [src]="sidebar.ActiveSidebar.img"
            height="50"
            width="50"
            alt=""
          />
          <div class="logo_name">{{ sidebar.ActiveSidebar.name }}</div>
        </div>

        <div
          class="tw-my-8 tw-border-b-4 tw-border-b-pink-700"
          *ngFor="let btn of sidebar.ButonsData"
        >
          <app-sidenav-btn [button]="btn"></app-sidenav-btn>
        </div>
      </div>
    </ng-scrollbar>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-toolbar></app-toolbar>
    <!--  The total content of the application-->
    <main class="main-content">
      <router-outlet class="tw-w-full tw-h-full"></router-outlet>
    </main>
  </mat-sidenav-content>

  <!--    Header-->

  <!--  <mat-sidenav-content>-->
  <!--  </mat-sidenav-content>-->
  <!--  hello world-->
</mat-sidenav-container>

<mat-menu #menuSideNav style="background: #111827 !important">
  <button
    mat-menu-item
    *ngFor="let op of sidebar.SideBars"
    class="menu-item-sidenav"
    (click)="changeSideNavActive(op)"
  >
    <img [src]="op.icon" height="50" width="50" alt="" />
    <div style="font-size: 20px !important">{{ op.name }}</div>
  </button>
</mat-menu>
